import { AdditionalImage } from './hotels_response_model';
import { ExternalReference, Reservations } from './reservations.model';

export interface Purchases {
  id?: string;
  type: SalesApplication;
  order_number: string;
  customer_order_id: string;
  name?: string;
  room_type_name?: string;
  stay_period?: string;
  reserved_for?: string;
  purchase_timestamp?: string;
  amount?: string;
  last_four_digits?: string;
  state?: string;
  isModify: boolean;
  modifyUrl: string;
  currency_code?: string;
  hotel_code?: string;
  checkout_date?: string;
  checkin_date?: string;
  external_references?: ExternalReference[];
  is_thirdparty?: boolean;
  imageData?: AdditionalImage;
  parent_reservation?: Reservations;
  reservation_index: number;
}

export enum SalesApplication {
  Hotel = 'HOTEL-ICE',
  Package = 'VP-ICE',
}
